// extracted by mini-css-extract-plugin
export default {"container":"Card_container__3wpVX","dark":"Card_dark__gc18n","title":"Card_title__URhiP","action":"Card_action__QV63w"};